import React from 'react';
import PrivacyPolicy from '../PricvacyPolicy';

const EquityNotePrivacyPolicy = () => {

  console.log("EquityNote component rendering");
    const appSpecificContent = {
      en: {
        developer: "Developer: 물가의새",
        title: "Stock Diary Privacy Policy",
        lastUpdated: "Last Updated: August 8, 2025",
        collectInfo: "1. Information We Collect",
        collectDescription:
          "In Stock Diary, we collect the following information to provide our investment tracking services:",
        collectList: [
          "Trading records including stock symbols, purchase/sale prices, and transaction dates",
          "Investment analysis data and personal notes",
          "Portfolio performance metrics and statistics",
          "App usage preferences and customization settings"
        ],
        usagePurpose: "2. Purpose of Information Use",
        usageDescription: "Your information helps us to:",
        usageList: [
          "Provide personalized investment tracking and analysis",
          "Generate portfolio performance reports and insights",
          "Deliver relevant investment notifications and reminders",
          "Improve service quality through anonymous usage analysis"
        ],
        dataSharing: "3. Data Sharing & Third-Party Disclosure",
        sharingDescription:
          "Stock Diary does not share personal investment data with third parties. Anonymous, aggregated investment statistics may be shared with analytics partners to improve our services.",
        dataStorage: "4. Data Retention & Deletion",
        storageDescription:
          "Your investment data is stored securely for as long as you maintain an active account. You can export or delete your data at any time through the app settings.",
        contact: "5. Contact",
        contactDescription: "For any privacy-related inquiries about Stock Diary, please contact EquityNote@gmail.com",
        changeLang: "Change to Korean",
      },
      ko: {
        developer: "개발자: 물가의새",
        title: "매매일지 개인정보처리방침",
        lastUpdated: "최종 업데이트 날짜: 2025년 8월 8일",
        collectInfo: "1. 수집하는 정보",
        collectDescription:
          "매매일지에서는 투자 추적 서비스를 제공하기 위해 다음 정보를 수집합니다:",
        collectList: [
          "주식 종목, 매수/매도 가격, 거래 날짜를 포함한 거래 기록",
          "투자 분석 데이터 및 개인 메모",
          "포트폴리오 성과 지표 및 통계",
          "앱 사용 환경설정 및 개인화 설정"
        ],
        usagePurpose: "2. 정보 이용 목적",
        usageDescription: "수집된 정보는 다음 목적으로 이용됩니다:",
        usageList: [
          "개인화된 투자 추적 및 분석 서비스 제공",
          "포트폴리오 성과 리포트 및 인사이트 생성",
          "관련 투자 알림 및 리마인더 전달",
          "익명 사용 분석을 통한 서비스 품질 개선"
        ],
        dataSharing: "3. 정보의 공유 및 제3자 제공",
        sharingDescription:
          "매매일지는 개인 투자 정보를 제3자와 공유하지 않습니다. 서비스 개선을 위해 익명화된 집계 투자 통계는 분석 파트너와 공유될 수 있습니다.",
        dataStorage: "4. 정보의 보존 및 삭제",
        storageDescription:
          "투자 정보는 계정이 활성화되어 있는 동안 안전하게 보관됩니다. 앱 설정을 통해 언제든지 정보를 내보내거나 삭제할 수 있습니다.",
        contact: "5. 연락처",
        contactDescription: "매매일지와 관련된 개인정보보호 문의는 EquityNote@gmail.com으로 연락 주세요.",
        changeLang: "영어로 변경",
      },
    };

  return <PrivacyPolicy customContent={appSpecificContent} />;
};

export default EquityNotePrivacyPolicy;